export interface NavigationLink {
  name: string
  path: string
}

export const navigationLinks: NavigationLink[] = [
  {
    name: 'Inicio',
    path: '/'
  },
  {
    name: 'Política',
    path: '/politica'
  },
  {
    name: 'Sociedad',
    path: '/sociedad'
  },
  {
    name: 'Tecnología',
    path: '/tecnologia'
  },
  {
    name: 'Cultura',
    path: '/cultura'
  },
  {
    name: 'Salud',
    path: '/salud'
  }
]